import { useRouter } from "next/router";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button } from "src/components/rough/Button";
import { Dialog } from "src/components/rough/Dialog";
import { Label } from "src/components/rough/Label";
import { TextInput } from "src/components/rough/TextInput";
import { useCreatePsychoed } from "src/data/mutations/psychoeds/usePsychoedMutations";
import { NumberInput } from "../../NumberInput";
import { Textarea } from "../../Textarea";

type CreatePsychoedDialogProps = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
};

export const CreatePsychoedDialog = ({ open, onOpenChange }: CreatePsychoedDialogProps) => {
  const router = useRouter();

  const [createPsychoed] = useCreatePsychoed();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [estimatedMinutes, setEstimatedMinutes] = useState<number | undefined>(undefined);

  const addPsychoed = () => {
    if (name === "") {
      toast.error("Please pick a name for your Educational Material.");
      return;
    }

    if (!estimatedMinutes) {
      toast.error("Please pick an estimated time for your educational material.");
      toast.info("The minimum time is 1; you can change this later.");
      return;
    }

    createPsychoed({
      variables: {
        description,
        name,
        estimatedMinutes,
      },
    })
      .then((res) => {
        const id = res.data?.addPsychoed?.id;
        if (!id) return;

        router.push(`/psychoeds/${id}`);
      })
      .finally(() => {
        setName("");
        setDescription("");
      });
  };

  return (
    <Dialog.Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Title>Create an Educational Material</Dialog.Title>
        <Dialog.Description>Create a brand new educational material</Dialog.Description>
        <div className="mt-4">
          <Label htmlFor="PsychoedNameInput">Name</Label>
          <TextInput
            className="mt-2"
            id="PsychoedNameInput"
            onValueChange={(e) => setName(e.target.value)}
            value={name}
            placeholder={"What is CBT"}
          />

          <div className="mt-4 flex flex-col gap-2">
            <Label htmlFor="PsychoedDescInput">Description</Label>
            <Textarea
              id="PsychoedDescInput"
              onValueChange={(e) => setDescription(e.target.value)}
              value={description}
              placeholder={"Help people understand this educational material at a glance"}
            />
          </div>

          <div className="mt-4">
            <Label htmlFor="EstimatedMinutesInput">Estimated Minutes</Label>
            <p className="text-sm text-gray-500">You can change this later</p>
            <NumberInput
              min={1}
              className="mt-2"
              id="EstimatedMinutesInput"
              onNativeChange={(e) =>
                setEstimatedMinutes(
                  // this doesn't make much sense, why would this be NaN. Value should
                  // be a number, not undefined.
                  Number.isNaN(Number(e.target.value)) ? 0 : Number(e.target.value),
                )
              }
              value={estimatedMinutes}
              placeholder={"You can change this later"}
            />
          </div>
        </div>

        <Dialog.Footer>
          <Button variant="primary" text={"Create"} onClick={addPsychoed} />

          <Dialog.Close>
            <Button variant="ghost" text="Cancel" />
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Dialog>
  );
};
